export const shouldSkipStoreDialogLogic = ({
  isStoreUnavailable,
  isCurrentPathExcluded,
  isDialogOpen,
  isSelectingStore,
  isRestaurantSearchLoading,
  noStoreSelected,
}: {
  isStoreUnavailable: boolean;
  isCurrentPathExcluded: boolean;
  isDialogOpen: boolean;
  isSelectingStore: boolean;
  isRestaurantSearchLoading: boolean;
  noStoreSelected: boolean;
}) => {
  return (
    !isStoreUnavailable ||
    isCurrentPathExcluded ||
    isDialogOpen ||
    isSelectingStore ||
    isRestaurantSearchLoading ||
    noStoreSelected
  );
};
